<nav aria-label="Sections" class="flex gap-1 border-b border-slate-200 px-4">
  <a
    routerLink="nyc-sync"
    routerLinkActive
    ariaCurrentWhenActive="page"
    #nycSyncLink="routerLinkActive"
    class="-mb-px border-b-2 px-4 py-3 text-sm font-medium no-underline hover:bg-slate-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
    [class.border-blue-600]="nycSyncLink.isActive"
    [class.text-blue-600]="nycSyncLink.isActive"
    [class.border-transparent]="!nycSyncLink.isActive"
    [class.text-slate-600]="!nycSyncLink.isActive"
    >NYC Sync</a
  >
  <a
    routerLink="users"
    routerLinkActive
    ariaCurrentWhenActive="page"
    #usersLink="routerLinkActive"
    class="-mb-px border-b-2 px-4 py-3 text-sm font-medium no-underline hover:bg-slate-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
    [class.border-blue-600]="usersLink.isActive"
    [class.text-blue-600]="usersLink.isActive"
    [class.border-transparent]="!usersLink.isActive"
    [class.text-slate-600]="!usersLink.isActive"
    >Users</a
  >
  <a
    routerLink="monitoring"
    routerLinkActive
    ariaCurrentWhenActive="page"
    #monitoringLink="routerLinkActive"
    class="-mb-px border-b-2 px-4 py-3 text-sm font-medium no-underline hover:bg-slate-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
    [class.border-blue-600]="monitoringLink.isActive"
    [class.text-blue-600]="monitoringLink.isActive"
    [class.border-transparent]="!monitoringLink.isActive"
    [class.text-slate-600]="!monitoringLink.isActive"
    >Monitoring</a
  >
  <a
    routerLink="support-email"
    routerLinkActive
    ariaCurrentWhenActive="page"
    #supportEmailLink="routerLinkActive"
    class="-mb-px border-b-2 px-4 py-3 text-sm font-medium no-underline hover:bg-slate-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
    [class.border-blue-600]="supportEmailLink.isActive"
    [class.text-blue-600]="supportEmailLink.isActive"
    [class.border-transparent]="!supportEmailLink.isActive"
    [class.text-slate-600]="!supportEmailLink.isActive"
    >Support email</a
  >
</nav>
<main>
  <router-outlet/>
</main>
